export const initialSupervisionData = {
    assessmentBiometrics: null,
    assessmentCompleteness: null,
    remarkBiometrics: null,
    assessmentQuestion: null,
    assessmentDiagnosis: null,
    remarkGrading: null,
};
